import { Position, State } from 'src/types'
import { hJointWeb, hWeb } from 'src/features/brands/treasure/canvas/glove/back/web/hWeb'
import { flatWeb } from 'src/features/brands/treasure/canvas/glove/back/web/flatWeb'
import { crossWeb } from 'src/features/brands/treasure/canvas/glove/back/web/crossWeb'
import { crossWebSingleKnot } from 'src/features/brands/treasure/canvas/glove/back/web/crossWebSingleKnot'
import { crossJointWebWithLace, crossWebWithLace } from 'src/features/brands/treasure/canvas/glove/back/web/crossWebWithLace'
import { onePeaceWeb } from 'src/features/brands/treasure/canvas/glove/back/web/onePeaceWeb'
import { vWeb } from 'src/features/brands/treasure/canvas/glove/back/web/vWeb'
import { netWeb2 } from 'src/features/brands/treasure/canvas/glove/back/web/netWeb2'
import { netWebDouble } from 'src/features/brands/treasure/canvas/glove/back/web/netWebDouble'
import { crossDoubleWebWithLace } from 'src/features/brands/treasure/canvas/glove/back/web/crossDoubleWebWithLace'
import { basketForPitcherWeb } from 'src/features/brands/treasure/canvas/glove/back/web/basketWeb'
import { fenceWeb } from 'src/features/brands/treasure/canvas/glove/back/web/fenceWeb'
import { crossWebWithHalfNetLace } from 'src/features/brands/treasure/canvas/glove/back/web/crossWebWithHalfLaceWeb'
import { jointCheckerWeb } from 'src/features/brands/treasure/canvas/glove/back/web/jointCheckerWeb'
import { netWeb3 } from 'src/features/brands/treasure/canvas/glove/back/web/netWeb3'
import { lacingNetWeb } from 'src/features/brands/treasure/canvas/glove/back/web/lacingNetWeb'
import { lacingCrownNetWeb } from 'src/features/brands/treasure/canvas/glove/back/web/lacingCrownNetWeb'
import { lacingWeb1 } from 'src/features/brands/treasure/canvas/glove/back/web/lacingWeb1'
import { wt1Web } from 'src/features/brands/treasure/canvas/glove/back/web/wt1Web'
import { wt2Web } from 'src/features/brands/treasure/canvas/glove/back/web/wt2Web'
import { wt3Web } from 'src/features/brands/treasure/canvas/glove/back/web/wt3Web'
import { wt4Web } from 'src/features/brands/treasure/canvas/glove/back/web/wt4Web'
import { wt7Web } from 'src/features/brands/treasure/canvas/glove/back/web/wt7Web'
import { wt8Web } from 'src/features/brands/treasure/canvas/glove/back/web/wt8Web'
import { wt9Web } from 'src/features/brands/treasure/canvas/glove/back/web/wt9Web'
import { wt10Web } from 'src/features/brands/treasure/canvas/glove/back/web/wt10Web'
import { wt11Web } from 'src/features/brands/treasure/canvas/glove/back/web/wt11Web'
import { wt5Web } from 'src/features/brands/treasure/canvas/glove/back/web/wt5Web'
import { crossWebWithCenterLaceWithCrossLace } from 'src/features/brands/treasure/canvas/glove/back/web/crossWebWithCenterLaceWithCrossLace'
import { crossWithCrossLaceWeb } from 'src/features/brands/treasure/canvas/glove/back/web/crossWithCrossLaceWeb'

export const webOfGloveBackDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  // 基本モデルのウェブを抽出
  const defaultWeb = state.webParts?.value === 'unselected' && state.baseModel.webParts

  // バスケットウェブ(投手用)
  const condBasketPitcherWeb = ['w3'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condBasketPitcherWeb) basketForPitcherWeb(ctx, state.web.color, state.lace.color, state.stitch.color)

  // フラットウェブ(投手用)
  const condFlatWeb = ['w5'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condFlatWeb) flatWeb(ctx, state.web.color, state.lace.color, state.stitch.color)

  // 十字ウェブ(結び目2つ)
  const condCrossWeb = ['w6'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condCrossWeb) {
    crossWeb(ctx, state.web.color, state.lace.color, state.stitch.color)
  }
  // 十字ウェブ(センターライン革紐付き)
  const condCrossWebWithCenterLace = ['w8'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condCrossWebWithCenterLace) {
    crossWebWithLace(ctx, state.web.color, state.lace.color, state.stitch.color)
  }
  // 十字ウェブ(センターライン革紐・x紐付き)
  const condCrossWebWithCenterLaceWithCross = ['w10'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condCrossWebWithCenterLaceWithCross) {
    crossWebWithCenterLaceWithCrossLace(ctx, state.web.color, state.lace.color, state.stitch.color)
  }
  const condHWeb = ['w11'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condHWeb) {
    hWeb(ctx, state.web.color, state.lace.color, state.stitch.color)
  }
  // レーシングネット＿王冠
  const condLacingCrownNetWeb = ['w12'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condLacingCrownNetWeb) lacingCrownNetWeb(ctx, state.web.color, state.lace.color, state.stitch.color)
  // レーシングネット
  const condLacingNetWeb = ['w13'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condLacingNetWeb) lacingNetWeb(ctx, state.web.color, state.lace.color, state.stitch.color)
  // ネットウェブ3
  const condNetWeb3 = ['w14'].some((x) => [state.webParts?.value, defaultWeb, defaultWeb].includes(x))
  if (condNetWeb3) {
    netWeb3(ctx, state.web.color, state.lace.color, state.stitch.color)
  }
  // ネットウェブ紐増量
  const condNetWebDouble = ['w15'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condNetWebDouble) {
    netWebDouble(ctx, state.web.color, state.lace.color, state.stitch.color)
  }
  // レーシングウェブ＿外野用
  const condLacing1 = ['w16'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condLacing1) {
    lacingWeb1(ctx, state.web.color, state.edge.color, state.lace.color, state.stitch.color)
  }
  // ネットウェブ2
  const condNetWeb2 = ['w17'].some((x) => [state.webParts?.value, defaultWeb, defaultWeb].includes(x))
  if (condNetWeb2) {
    netWeb2(ctx, state.web.color, state.edge.color, state.lace?.color, state.stitch.color)
  }
  // 横二本の外野手用クロスウェブ(センターライン革紐付き)
  const condCrossDoubleWebWithLace = ['w19'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condCrossDoubleWebWithLace) {
    crossDoubleWebWithLace(ctx, state.web.color, state.lace.color, state.stitch.color)
  }
  // 十字ウェブ(半分：革紐編み込み付き)
  const condCrossWebWithHalfLace = ['w21'].some((x) => [state.webParts?.value, defaultWeb, defaultWeb].includes(x))
  if (condCrossWebWithHalfLace) {
    crossWebWithHalfNetLace(ctx, state.web?.color, state.lace?.color, state.stitch?.color)
  }

  // 十字ウェブ(結び目1つ付き)
  const condCrossWebSingleKnot = ['w22'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condCrossWebSingleKnot) {
    crossWebSingleKnot(ctx, state.web.color, state.lace.color, state.stitch.color)
  }
  // 柵ウェブ
  const condFenceWeb = ['w23'].some((x) => [state.webParts?.value, defaultWeb, defaultWeb].includes(x))
  if (condFenceWeb) {
    fenceWeb(ctx, state.web.color, state.lace.color, state.stitch.color)
  }
  // ワンピースウェブ
  const condOnePeaceWeb = ['w24'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condOnePeaceWeb) {
    onePeaceWeb(ctx, state.web.color, state.lace.color, state.stitch.color)
  }
  // Hウェブ(ジョイント付き)
  const condHJointWeb = ['w27'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condHJointWeb) {
    hJointWeb(ctx, state.web?.color, state.lace?.color, state.stitch?.color)
  }

  // 十字ウェブ(ジョイント・センターライン革紐付き)
  const condCrossJointWebWithLace = ['w28'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condCrossJointWebWithLace) {
    crossJointWebWithLace(ctx, state.web.color, state.lace.color, state.stitch.color)
  }
  // 十字ウェブ(結び目2つ)
  const condCrossWithCrossWeb = ['w29'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condCrossWithCrossWeb) {
    crossWithCrossLaceWeb(ctx, state.web.color, state.lace.color, state.stitch.color)
  }
  // Vウェブ
  const condVWeb = ['w30'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condVWeb) {
    vWeb(ctx, state.web.color, state.lace.color, state.stitch.color)
  }

  // フラットウェブ(投手用)
  const condWt1Web = ['wt1'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condWt1Web) wt1Web(ctx, state.web.color, state.lace.color, state.stitch.color)
  // フラットウェブ(投手用)
  const condWt2Web = ['wt2'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condWt2Web) wt2Web(ctx, state.web.color, state.lace.color, state.stitch.color)
  // フラットウェブ(投手用)
  const condWt3Web = ['wt3'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condWt3Web) wt3Web(ctx, state.web.color, state.lace.color, state.stitch.color)
  // フラットウェブ(投手用)
  const condWt4Web = ['wt4'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condWt4Web) wt4Web(ctx, state.web.color, state.lace.color, state.stitch.color)
  // フラットウェブ(投手用)
  const condWt5Web = ['wt5'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condWt5Web) wt5Web(ctx, state.web.color, state.lace.color, state.stitch.color)
  const condJointCheckerWeb = ['wt6'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condJointCheckerWeb) {
    jointCheckerWeb(ctx, state.web.color, state.web2?.color || state.web.color, state.lace.color, state.stitch.color)
  }
  // フラットウェブ(投手用)
  const condWt7Web = ['wt7'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condWt7Web) wt7Web(ctx, state.web.color, state.lace.color, state.stitch.color)

  const condWt8Web = ['wt8'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  // ネットウェブ紐増量（ジョイント）
  if (condWt8Web) {
    wt8Web(ctx, state.web.color, state.lace.color, state.stitch.color)
  }
  // if (condWt8Web) wt8Web(ctx, state.web.color, state.lace.color, state.stitch.color)
  // フラットウェブ(投手用)
  const condWt9Web = ['wt9'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condWt9Web) wt9Web(ctx, state.web.color, state.lace.color, state.stitch.color)
  // フラットウェブ_treasureオリジナル
  const condWt10Web = ['wt10'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condWt10Web) wt10Web(ctx, state.web.color, state.lace.color, state.stitch.color)
  // フラットウェブ_treasureオリジナル
  const condWt11Web = ['wt11'].some((x) => [state.webParts?.value, defaultWeb].includes(x))
  if (condWt11Web) wt11Web(ctx, state.web.color, state.lace.color, state.stitch.color)
}
